import { AppLayout } from '@/components/layout/AppLayout'
import { AtlasPage } from '@/components/ui/AtlasPage'
import { PageTitle } from '@/components/ui/PageTitle'
import { Separator } from '@/components/ui/Separator'
import { PageNumber } from '@/components/ui/PageNumber'
import { Button } from '@/components/ui/Button'
import { router } from '@inertiajs/react'
import { useConfirm } from '@/hooks/useConfirm'
import { ConfirmModal } from '@/components/ui/ConfirmModal'

interface Photo {
  id: number
  url: string
  thumbnail_url: string
}

interface Supply {
  id: number
  name: string
  description: string | null
  category: string
  category_pl: string
  photo: Photo | null
}

interface Props {
  supply: Supply
}

function SuppliesShow({ supply }: Props) {
  const { pending, confirm, handleConfirm, handleCancel } = useConfirm()

  const handleDelete = () => {
    confirm('Na pewno usunąć ten zapas?', () => router.delete(`/supplies/${supply.id}`))
  }

  return (
    <AtlasPage>
      <PageTitle title={supply.name} />
      <Separator />

      {supply.photo && (
        <div className="flex justify-center mb-md">
          <img
            src={supply.photo.url}
            alt={supply.name}
            className="max-h-64 object-contain border border-frame/20"
          />
        </div>
      )}

      <div className="grid grid-cols-1 gap-sm sm:grid-cols-2 text-sm">
        <DataRow label="Kategoria">{supply.category_pl}</DataRow>
      </div>

      {supply.description && (
        <>
          <Separator />
          <h2 className="font-display text-lg text-center uppercase tracking-wider text-ink mb-sm">
            Opis
          </h2>
          <p className="text-sm text-ink font-body whitespace-pre-line">{supply.description}</p>
        </>
      )}

      <Separator />
      <div className="flex items-center justify-center gap-sm">
        <Button href={`/supplies/${supply.id}/edit`} variant="secondary">Edytuj</Button>
        <Button variant="danger" onClick={handleDelete}>Usuń</Button>
      </div>

      <PageNumber number={11} />
      {pending && <ConfirmModal message={pending.message} onConfirm={handleConfirm} onCancel={handleCancel} />}
    </AtlasPage>
  )
}

function DataRow({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="flex gap-sm">
      <span className="font-label text-xs text-frame uppercase tracking-wide min-w-[8rem]">
        {label}:
      </span>
      <span className="text-ink">{children}</span>
    </div>
  )
}

SuppliesShow.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>
export default SuppliesShow
